import type { WorkflowActionConfigValue } from "@/model/interface/Workflow";

export function configString(value: WorkflowActionConfigValue | undefined): string {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    return String(value);
  }
  return "";
}

export function configNumberOrEmpty(value: WorkflowActionConfigValue | undefined): number | "" {
  if (typeof value === "number") {
    return value;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? "" : parsed;
  }
  return "";
}

export function extractOutcomeRouting(
  value: WorkflowActionConfigValue | undefined,
): Record<string, number | null> {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }
  const routing: Record<string, number | null> = {};
  for (const [outcomeName, routeValue] of Object.entries(value)) {
    if (routeValue === null) {
      routing[outcomeName] = null;
    } else if (typeof routeValue === "number") {
      routing[outcomeName] = routeValue;
    }
  }
  return routing;
}
